import { userManager } from 'core/configs/userManager'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

function useSigninRedirectCallback() {
  const navigate = useNavigate()

  useEffect(() => {
    ;(async () => {
      try {
        const user = await userManager.signinRedirectCallback()
        if (user !== null) navigate('/home')
      } catch (error) {
        console.error(
          'Error during sign-in redirect callback:',
          error,
          '\n\nThis error is expected in dev mode (React strict mode makes app to make 2 identical requests, second is expected to be error).'
        )
      }
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}

export function CallbackPage() {
  useSigninRedirectCallback()

  return (
    <div className="CallbackPage">
      <h1>Almost here...</h1>
      <p>We're redirecting you to the app. Please wait a moment.</p>
    </div>
  )
}
